import { generatePath } from 'react-router';

import { PATHS } from '@/shared/config';

import {
  OPEN_TRANSCRIPTOR_RECORDING_PARAM,
  TRANSCRIPTOR_LANDING_PATIENT_ID_PARAM,
} from '../config';

type BuildTranscriptorDeepLinkPathParams = {
  patientID: string;
  searchParams: URLSearchParams;
};

// Foreign params (X-Dc-*) must survive the redirect so that presign
// bootstrap can still store or reauthenticate from the patient page URL.
export const buildTranscriptorDeepLinkPath = ({
  patientID,
  searchParams,
}: BuildTranscriptorDeepLinkPathParams): string => {
  const passthroughParams = new URLSearchParams(searchParams);

  passthroughParams.delete(TRANSCRIPTOR_LANDING_PATIENT_ID_PARAM);
  passthroughParams.set(OPEN_TRANSCRIPTOR_RECORDING_PARAM, '1');

  return `${generatePath(PATHS.patient, { patientID })}?${passthroughParams}`;
};
